import { baseball } from './baseball';
import { basketball } from './basketball';
import { hockey } from './hockey';
import { rugby } from './rugby';
import { greek } from './greek';
import { soccer } from './soccer';
import { softball } from './softball';
import { apparel } from './apparel';

export const designNumbers = {
  baseball,
  rugby,
  softball,
  basketball,
  soccer,
  hockey,
  greek,
  apparel,
};
